import React from 'react'
import { Modal } from '../../components'

export const AlertModal = ({ title, body, onHide, ...rest }) => (
  <Modal onHide={onHide} {...rest}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{body}</Modal.Body>
    <Modal.Footer align="center"></Modal.Footer>
  </Modal>
)
